const quiz = [
	{
		question : 'First four numbers of Fibbonacci sequence are..?',
		answer   : '1123'
	},
	{
		question : "How long is  a girraffe's tongue? [cm]",
		answer   : '0045'
	},
	{
		question : 'In what year did Titanic sink?',
		answer   : '1912'
	},
	{
		question : 'In what year Apollo 11 landed on the Moon?',
		answer   : '1969'
	},
	{
		question : 'First four digits after the decimal of PI are..?',
		answer   : '1415'
	},
	{
		question : 'How many bones compose human body at birth?',
		answer   : '0270'
	},
	{
		question : 'What was the duration of Calhoun experiment (behavioral sink)? [days]',
		answer   : '1588'
	},
	{
		question : 'What is the first prime number?',
		answer   : '0002'
	},
	{
		question : `First four digits after the decimal of Euler's number`,
		answer   : '7182'
	},
	{
		question : 'How many websites existed in 1991?',
		answer   : '0001'
	},
	{
		question : 'For how many hours total each day (statistically) crocodiles keep both eyes closed?',
		answer   : '0017'
	},
	{
		question : 'In what year John Ronald Reuel Tolkien was born?',
		answer   : '1892'
	},
	{
		question : 'What was the number of the last Apollo mission?',
		answer   : '0017'
	},
	{
		question :
			'In what year famous book of the astronomer Nicolaus Copernicus - De revolutionibus orbium coelestium (On the Revolutions of the Heavenly Spheres) - was first printed?',
		answer   : '1543'
	},
	{
		question : 'How high is the Matterhorn? [m]',
		answer   : '4478'
	}
];

export default quiz;
